<template lang="html">
  <div>
    <div class="breadCrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{$t('message.group')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('message.groupManage')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="flex-row second-tip">
      <div class="title"></div>
      <div class="flex-row search-container">
        <el-input class="grouplist-search" :placeholder="$t('message.groupTip')" v-model="appManagementSearch"
          @keyup.enter.native="searchGrouplist" clearable />
        <el-button class="search-btn" icon="el-icon-search" @click="searchGrouplist"></el-button>
        <router-link :to="{path:'/groupAdd/'}">
          <el-button class="verifone-btn" type="primary" plain icon="el-icon-plus">{{$t('message.add')}}</el-button>
        </router-link>
      </div>
    </div>
    <div class="verifone-panel">
      <div class="appManagement-table-main btn-table">
        <template>
          <el-table :data="tableData" style="width: 100%">
            <!-- 组名 -->
            <el-table-column prop="groupName" :label="$t('message.groupName')" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <div class="nameHerf" @click="handleGroupName(scope.row)">{{scope.row.groupName}}</div>
              </template>
            </el-table-column>

            <!-- 终端数 -->
            <el-table-column prop="totalTerminals" :label="$t('message.terminals')"></el-table-column>

            <!-- 终端参数 -->
            <el-table-column :label="$t('message.terminalParam')" width="163" align="center">
              <template slot-scope="scope">
                <el-button v-if="scope.row.parameterEditMark" class="verifone-btn" type="success" plain icon="el-icon-edit" @click="modifyTerminalParameter(scope.row)">{{$t('message.edit')}}</el-button>
                <el-button v-else disabled class="verifone-btn" type="success" plain icon="el-icon-edit" @click="modifyTerminalParameter(scope.row)">{{$t('message.edit')}}</el-button>
              </template>
            </el-table-column>

            <!-- 操作 -->
            <el-table-column :label="$t('message.operation')" width="300" align="center">
              <template slot-scope="scope">
                <!--<router-link :to="{path:'/groupEdit/' + scope.row.id + '/' + scope.row.groupName}">
                  <el-button type="success" class="op-btn verifone-btn" plain icon="el-icon-edit" @click="">
                    {{$t('message.edit')}}
                  </el-button>
                </router-link>-->
                <el-button type="danger" class="op-btn verifone-btn" plain icon="el-icon-close" @click="showDeleteDialog(scope.row)">
                  {{$t('message.delete')}}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>

        <div class="pagination-main">
          <el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next" :current-page="pageNum"
            :page-count="pageCount">
          </el-pagination>
        </div>
      </div>


    </div>

    <el-dialog title="" :visible.sync="deleteTipVisible" custom-class="tips-dialog" class="quit-dialog warn-dialog">
      <div class="warn-container flex-row">
        <img class="warn-icon" alt="" src="static/img/alertWarn.png">
        <span>&nbsp;&nbsp;{{$t('message.warn')}}</span>
      </div>
      <div class="dialog-body">
        <span>{{$t('message.deleteGroup')}}</span><span>{{taskName}}</span><span>"?</span>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button class="verifone-btn" type="primary" plain @click="deleteTipVisible = false">{{$t('message.no')}}</el-button>
        <el-button class="verifone-btn" type="primary" @click="deleteApp">{{$t('message.yes')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        pageNum: 1,
        pageCount: 1,
        deleteGroupId: '',
        appManagementSearch: '',
        deleteTipVisible: false,
        researchType: 0, //0 为查询分页查询APP 1搜索APP
        tableData: [],
        taskName: '',
        deleteSuccess: this.$t('message.deleteSuccess')
      }
    },

    mounted() {
      this.quryGroupList();
    },

    methods: {
      // 跳转至终端参数编辑页面
      modifyTerminalParameter(row) {
        let groupId = row.id;
        let groupName = row.groupName;
        this.$router.replace('/groupTerminalParameter/' + groupId + '/' + groupName);
      },

      handleCurrentChange(val) {
        this.pageNum = val;
        if (this.researchType == 0) {
          this.quryGroupList();
        } else if (this.researchType == 1) {
          this.searchGrouplist();
        }
      },

      handleGroupName(row) {
        let groupId = row.id;
        let groupName = row.groupName;
        this.$router.replace('/groupEdit/' + groupId + '/' + groupName);
      },

      quryGroupList() {
        let that = this,
          obj = {
            pageNum: this.pageNum
          };

        this.$axios({
          method: 'post',
          url: '/marketplace/group/page',
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration: '3000',
            });
            return;
          } else {
            that.researchType = 0;
            //this.$refs.codeImg.src = response.data.image;
            that.pageCount = response.data.totalPage;
            that.tableData = response.data.groupList;
          }
        }).catch((err) => {
          console.log(err);
        });
      },

      searchGrouplist() {
        let that = this,
          obj = {
            queryInfo: this.appManagementSearch,
            pageNum: this.pageNum
          };

        this.$axios({
          method: 'post',
          url: '/marketplace/group/search',
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration: '3000',
            });
            return;
          } else {
            that.researchType = 1;
            that.tableData = response.data.groupList;
            that.pageCount = response.data.totalPage;
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      showDeleteDialog(row) {
        this.deleteTipVisible = true;
        this.deleteGroupId = row.id;
        this.taskName = row.groupName;
        console.log(row);
        console.log(row.date, row.name, row.id);
      },
      deleteApp() {
        let that = this,
          obj = {
            id: this.deleteGroupId
          };

        this.$axios({
          method: 'post',
          url: '/marketplace/group/delete',
          headers: {
            'Accept-Language': sessionStorage.getItem('acceptLanguage')
          },
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration: '3000',
            });
            return;
          } else {
            that.deleteGroupId = '';
            that.deleteTipVisible = false;
            that.$message({
              type: "success",
              message: this.deleteSuccess,
              duration: '3000',
            });
            if (that.researchType == 0) {
              that.quryGroupList();
            } else if (that.researchType == 1) {
              that.searchGrouplist();
            }
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    }
  }
</script>

<style lang="css" scoped="scope">
  .appManagement-container {
    /*background-color: #E0EAF4;*/
    overflow: hidden;
    display: flex;
    display: -webkit-flex;
    /*justify-content: center;*/
    align-items: center;
    width: 100%;
  }

  .appManagement-table {
    width: 100%;
    padding: 10px 30px;
  }

  .appManagement-table-main {
    padding: 20px;
    background-color: #fff;
  }

  .pagination-main {
    padding: 30px 0 10px;
    background: #fff;
    width: 100%;
  }

  .appManagement-search .el-input__inner {
    border-radius: 20px;
  }

  .grouplist-search {
    margin-right: 10px;
    width: 400px;
  }

  .nameHerf {
    color: #3ba2ec;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/Grouplist.vue